import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import './App.css';
import { AppActions } from './actions';
import { Link } from 'react-router-dom'
import GoogleAds from 'react-google-ads'


const MainContent = styled.div`
  width: 94%;
  margin: 0 auto;
  max-width: 800px;
  padding: 16px 0;
`

const Card = styled.div`
  background: #fff;
  padding: 28px 20px;
  line-height: 1.6;
  font-size: 15px;
  border-radius: 5px;
`

const StrongText = styled.span`
  display: inline-block;
  margin: 0 6px;
  font-weight: bold;
  font-size: 24px;
  line-height: 1.8;
  color: #4db3b6;
`

const ResultMainText = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
`

const Point = styled.h2`
  display: block;
  margin: 0 auto 36px; 
  width: 80px;
  color: #444;
  background: linear-gradient(transparent 70%, #fbc78d 70%);
  text-align: center;
  font-size: 16px;
  font-weight: bold;
`

const ResultWrap = styled.div`
  text-align: center;
  border: 2px solid #85cbcd;
  width: 80%;
  margin: 0 auto 20px;
  border-radius: 5px;
  max-width: 300px;
`

const ResultTitle = styled.p`
  line-height: 1.4;
  font-size: 14px;
  font-weight: bold;
  background: #85cbcd;
  color: #fff;
  padding: 8px 0;
`

const ResultNumber = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin-top: 4px;
  padding: 6px 0;
`

const SnsButton = styled.a`
  background: #fbc78d;
  text-decoration: none;
  padding: 10px 0;
  text-align: center;
  width: 70%;
  display: block;
  margin: 0 auto;
  color: #fff;
  border-radius: 8px;
  font-weight: bold;
  max-width: 300px;
`

const TwitterLink = styled.a`
  display: block;
  text-align: center;
  color: #928484;
  margin-top: 40px;
  font-size: 14px;
`

const TwitterIcon = styled.span`
  display: inline-block;
  margin-right: 5px;
  background: #928484;
  color: #fff;
  padding: 4px 4px;
  border-radius: 50%;
`

const PointBlock = styled.div`
  margin-bottom: 32px;
`

const CheckTextTitle = styled.p`
  margin-bottom: 12px;
  font-weight: bold;
`

const CheckTitle = styled.span`
  display: inline-block;
  margin-right: 6px;
  font-size: 17px;
  color: #85cbcd;
`

const CheckList = styled.ul`
  list-style: disc;
  padding-left: 30px;
  > li {
    margin-bottom: 6px;
  }
`

const Footer = styled.footer`
  margin-top: 60px;
  background: #666;
  font-size: 12px;
  color: #fff;
  a {
    color: #fff;
  }
`

class ResultScreen extends Component {
  render() {
    const {
      resultImpression,
      resultProfile,
      resultNewFollower,
      resultTweet,
      isOver1000Follower,
    } = this.props;

    let shareText;
    
    if (isOver1000Follower) {
      shareText = "【あなたのフォロワーはすでに1000人を超えています】"
    } else {
      shareText = `【${resultTweet} 回ツイートするとフォロワー1000人になります】`; 
    }

    return (
      <div>
        <MainContent>
          <Card style={{ marginBottom: '30px' }}>
            {isOver1000Follower &&
              <ResultMainText>
                あなたのフォロワーはすでに<br />1000人を超えています
              </ResultMainText>
            }
            {!isOver1000Follower &&
              <ResultMainText>
                あなたは<StrongText>{resultTweet}</StrongText>回
                ツイートすると<br />1000人になります
              </ResultMainText>
            }
            <ul>
              <li>
                <ResultWrap>
                  <ResultTitle>1回のツイートあたりの<br />インプレッション数</ResultTitle>
                  <ResultNumber>{resultImpression}</ResultNumber>
                </ResultWrap>
              </li>
              <li>
                <ResultWrap>
                  <ResultTitle>1インプレッションあたりの<br />プロフィール閲覧率</ResultTitle>
                  <ResultNumber>{resultProfile} %</ResultNumber>
                </ResultWrap>
              </li>
              <li>
                <ResultWrap>
                  <ResultTitle>1回のプロフィール閲覧あたりの<br />新規フォロワー率</ResultTitle>
                  <ResultNumber>{resultNewFollower} %</ResultNumber>
                </ResultWrap>
              </li>
            </ul>
            <TwitterLink href={"https://twitter.com/share?url=https://twitter-analysis-yuugram.firebaseapp.com&text=" + shareText + "&hashtags=フォロワー1000人までの道"}>
              <TwitterIcon className="fab fa-twitter"></TwitterIcon>結果をシェアする
            </TwitterLink>
          </Card>
          <Card style={{ padding: '33px 0', marginBottom: '30px' }} >
            <Point>ポイント</Point>
            <div style={{ padding: '0 30px' }}>
              <PointBlock>
                <CheckTextTitle>
                  <CheckTitle
                    className="fas fa-check"
                  />
                  1回のツイートあたりのインプレッション数を増やすには
                </CheckTextTitle>
                <CheckList>
                  <li>フォロワーさんに反応してもらえるツイート内容を心がけましょう</li>
                  <li>フォロワーの1％が反応してくれる内容で狙い撃ちして発信しましょう</li>
                </CheckList>
              </PointBlock>
              <PointBlock>
                <CheckTextTitle>
                  <CheckTitle
                    className="fas fa-check"
                  />
                  1インプレッションあたりのプロフィール閲覧率を増やすには
                </CheckTextTitle>
                <CheckList>
                  <li>人に共感してもらえる発信を心がけましょう</li>
                  <li>何者なのかを簡単に理解してもらえる名前にしましょう</li>
                </CheckList>
              </PointBlock>
              <PointBlock>
                <CheckTextTitle>
                  <CheckTitle
                    className="fas fa-check"
                  />
                  1回のプロフィール閲覧あたりの新規フォロワー率を増やすには
                </CheckTextTitle>
                <CheckList>
                  <li>プロフ160文字Maxで自分の紹介をしましょう</li>
                  <li>自分のフォローするメリットが書かれているとフォローしやすいです</li>
                </CheckList>
              </PointBlock>
            </div>
          </Card>
          <Card style={{ textAlign: 'center', padding: '33px 0', marginBottom: '40px' }} >
            <p style={{ fontSize: '13px', marginBottom: '4px' }}>無料相談はこちら！</p>
            <SnsButton
              href="https://twitter.com/matsu_marketer"
              target="_blank"
              rel="noopener noreferrer"
            >作成者をフォローする</SnsButton>
            <p style={{ fontSize: '13px', margin: '32px 0 4px' }}>
              役に立ったなあと思ったら<br />よければ投げ銭お願いします…！
            </p>
            <SnsButton
              href="https://polca.jp/projects/PSMICkszM3S"
              target="_blank"
              rel="noopener noreferrer"
            >Polca</SnsButton>
          </Card>
          <p
            style={{ fontSize: '12px', textAlign: 'center', color: '#aaa' }}
          >スポンサードリンク</p>
          <GoogleAds
            client="ca-pub-4507356323905232"
            slot="2679871912"
            className="adsbygoogle"
            format="auto"
            style={{display: 'block'}}
          />
        </MainContent>
        <Footer>
          <MainContent>
            <div style={{ marginBottom: '20px', fontSize: '14px' }}>
              <Link to='/' style={{ marginRight: '12px'}}>トップ</Link> 
              <Link to='/privacy-policy'>プライバシーポリシー</Link> 
            </div>
            <p>© 2018 <a href="https://twitter.com/yu_webmemo" target="_blank" rel="noopener noreferrer">@yu_webmemo</a> & <a href="https://twitter.com/matsu_marketer" target="_blank" rel="noopener noreferrer">@matsu_marketer</a></p>
          </MainContent>
        </Footer>
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  return {
    resultImpression: app.resultImpression,
    resultProfile: app.resultProfile,
    resultNewFollower: app.resultNewFollower,
    resultTweet: app.resultTweet,
    isOver1000Follower: app.isOver1000Follower,
  };
};

export default connect(mapStateToProps, AppActions)(ResultScreen);



// WEBPACK FOOTER //
// ./src/ResultScreen.js